<script lang="ts" setup>
import {
  mdiArrowRightThin,
  mdiChartBar,
  mdiHandCoin,
  mdiImport,
  mdiPencilBoxOutline,
  mdiPlayBoxMultipleOutline,
  mdiSchoolOutline,
  mdiShuffleVariant,
  mdiWeb,
} from "@mdi/js";
import { useTranslate } from "@/composables/use-translate";

const { t } = useTranslate();

const features = [
  {
    icon: mdiSchoolOutline,
    title: "Methode onafhankelijk",
    tekst: `Taalblobs sluit aan bij alle gangbare schoolmethodes`,
    to: "didactiek",
  },
  {
    icon: mdiShuffleVariant,
    title: "Adaptief",
    tekst: `Het adaptieve algoritme selecteert automatisch de juiste oefening`,
    to: "adaptief",
  },
  {
    icon: mdiPencilBoxOutline,
    title: "Aangepaste taken",
    tekst: `Stel handmatig aangepaste oefeningen in voor de individuele leerling of voor de gehele ${t("groep")}.`,
    to: "aangepast-oefenen",
  },
  {
    icon: mdiChartBar,
    title: "Voortgang volgen",
    tekst: `Gedetailleerde voortgangsrapportage met o.a. een foutenanalyse op woord- en regelniveau`,
    to: "voortgang-volgen",
  },
  {
    icon: mdiWeb,
    title: "Web based",
    tekst: `Met één account kan overal worden geoefend. Bijvoorbeeld dus op school én thuis.`,
    to: "web-based",
  },
  {
    icon: mdiImport,
    title: "importeren van EdexML en svt",
    tekst: `Importeren van ${t("groepen")} en leerlingen (EdexML) en van toetsresultaten (SVT spelling)`,
    to: "instructie",
  },
  {
    icon: mdiPlayBoxMultipleOutline,
    title: "Instructievideo's",
    tekst: `Door de vele instructievideo's kunt u snel en gemakkelijk met Taalblobs aan de slag`,
    to: "instructie",
  },
  {
    icon: mdiHandCoin,
    title: "Betaalbare kwaliteit",
    tekst: `een kwalitatief hoogwaardig product voor een scherpe prijs`,
    to: "prijzen",
  },
];
</script>

<template>
  <v-container class="py-16" style="max-width: 80rem">
    <div class="pt-4">
      <h2 style="font-size: 2rem">De kernpunten van Taalblobs</h2>
      <p class="pb-8">
        Taalblobs is een veelzijdig programma met zeer veel mogelijkheden. Een
        overzicht van de kernpunten die beschikbaar zijn:
      </p>
    </div>

    <v-row>
      <v-col v-for="(feature, i) in features" :key="i" cols="12" md="6">
        <div class="d-flex align-start">
          <div class="bg-blue-lighten-4 pa-1 rounded-circle">
            <div class="bg-blue-darken-2 rounded-circle pa-3">
              <v-icon size="32">{{ feature.icon }}</v-icon>
            </div>
          </div>
          <div class="pl-6">
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.tekst }}</p>
            <v-btn
              :to="{ name: feature.to }"
              color="primary"
              class="px-0"
              variant="text"
              slim
            >
              Lees verder <v-icon>{{ mdiArrowRightThin }}</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
